<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">

  <mat-card appearance="outlined">
    <mat-card-title>Infos: {{screen.productName}} - {{screen.remark}}</mat-card-title>
    <mat-list>
      <mat-list-item>
        <span class="label">Screen UUID: </span><span>{{screen.uuid}}</span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">Screen ID: </span><span>{{screen._id}}</span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">ProductName:  </span><span>{{screen.productName}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="organisationCustomer">
        <span class="label">Organisation Customer: </span><span>{{organisationCustomer}}</span>
      </mat-list-item>
    </mat-list>
  </mat-card>

  <div class="spacer"></div>
  <mat-card appearance="outlined">
    <mat-card-title class="json-list-title">Custom JSONs</mat-card-title>
    <data-table #jsonTable
                    (detail)="navigateToJsonDetail($event)"
                    (edit)="navigateToJsonEdit($event)"
                    (remove)="removeJson($event)"
                    [columns]="jsonDataTableColumns"
                    [dataProviderParams]="jsonDataProviderParams"
                    [dataProvider]="jsonService"
                    [hideSearch]="true"></data-table>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>Links</mat-card-title>

    <mat-card appearance="outlined">
      <mat-card-title>Preview Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/preview.html" target="_blank">{{urlBase}}/preview.html</a>
      <br/>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/preview.html#touch2go" target="_blank">{{urlBase}}/preview.html#touch2go</a>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined">
      <mat-card-title>Touch2015 Standard Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/screen.html" target="_blank">{{urlBase}}/screen.html</a>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined">
      <mat-card-title>Touch2015 Mobile Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/app.html" target="_blank">{{urlBase}}/app.html</a>
    </mat-card>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>Redirects</mat-card-title>
    <data-table (detail)="navigateToRedirect($event)"
                    *ngIf="redirects && redirects.length"
                    [columns]="redirectDataTableColumns"
                    [hideSearch]="true"
                    [plainData]="redirects"></data-table>
  </mat-card>

</page-content>
